import {translateName} from "../../../../utils/i18n";
import _ from "lodash";

const getElementFullName = (object, context) => {
    if (object.joinedEntity === 'Unit') {
        return `Groupe : ${object.code} - ${object.name}`
    } else {
        return `Société : ${object.code} - ${object.name}`
    }
}

export const entity = require('../../../utils/entityJoin').joinEntities(
    {
        name: 'GroupAndCompany',
        fields: [
            {
                path: 'fullName',
                fieldPath: ['organizationalAxis.name', 'attachments.name'],
                $f: (object, context, callback) => {
                    callback(null, getElementFullName(object, context))
                }
            }
        ]
    },
    ['Unit', 'Company']
)
